import React, {Component, Fragment, ReactElement} from 'react';
import { connect } from "react-redux";
import {IRootState} from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import Table, {TableColumn} from "../../../Table";
import {CommandBarButton} from "office-ui-fabric-react";
import JsonViewerCard from "../../../JsonViewerCard";
import TableCell from "../../../TableCell";
import {Permission, Site} from "@microsoft/microsoft-graph-types";
import SchoolPageTitle from '../../../SchoolPageTitle';
import AdminSchoolMenu from '../../../AdminSchoolMenu';
export interface SiteExploreResult
{
    site: Site
    permissions: Permission[];
}

interface ExploreSitePageProps {
    tenantId: string;
    schoolCode: string;
    siteId: string;
    apiService: ApiService;
}

interface ExploreSitePageState {
    siteExploreResult?: SiteExploreResult;
    showJson: boolean;
}

const SITE_COLUMNS: TableColumn[] = [
    {title: "Id",propertyPath: "id",enableSort: false, flex: 1},
    {title: "Display Name",propertyPath: "displayName",enableSort: false, flex: 1},
    {title: "Name",propertyPath: "name",enableSort: true, flex: 1},
    {title: "Web Url",propertyPath: "webUrl",enableSort: false, flex: 1},
    {title: "Created At",propertyPath: "createdDateTime",enableSort: true, type: "date", flex: 1},
];

const SITE_PERMISSION_COLUMNS: TableColumn[] = [
    {title: "Id",propertyPath: "id",enableSort: false, flex: 1},
];

class ExploreSitePage extends Component<ExploreSitePageProps & DispatchProps, ExploreSitePageState> {
    static displayName = ExploreSitePage.name;

    constructor(props: ExploreSitePageProps & DispatchProps) {
        super(props);

        this.state = {
            siteExploreResult: undefined,
            showJson: false
        }
    }

    async componentDidMount() {
        const siteExploreResult = await this.props.apiService.exploreSite(this.props.tenantId,this.props.schoolCode,this.props.siteId);

        this.setState({
            siteExploreResult
        });
    }

    async componentDidUpdate(prevProps: Readonly<ExploreSitePageProps & DispatchProps>, prevState: any): Promise<void> {

    }
    
    private cellForColumn = (item: Site, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {

        if(column.propertyPath === "webUrl")
        {
            return (
                <TableCell flex={column.flex}>
                    <a href={item.webUrl} target={"_blank"}>
                        {item.webUrl}
                    </a>
                </TableCell>
            );
        }
    }
    
    render() {

        
        const jsonButton = (
            <CommandBarButton
                iconProps={{ iconName: "code" }}
                text={"Show json"}
                onClick={() => {
                    this.setState({ showJson: true })
                }}
            />
        );

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Explore Site" /> 

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                {this.state.showJson ?
                    <JsonViewerCard title={""} jsonObject={this.state.siteExploreResult!}>
                        <CommandBarButton
                            iconProps={{ iconName: "cancel" }}
                            text={"Close"}
                            onClick={() => {
                                this.setState({ showJson: false })
                            }}
                        />
                    </JsonViewerCard> : null}

                <Table
                    title={this.state.siteExploreResult?.site.displayName}
                    columns={SITE_COLUMNS}
                    cellForColumn={this.cellForColumn}
                    items={this.state.siteExploreResult?.site ? [this.state.siteExploreResult.site] : []}>
                    {this.state.showJson ? null : jsonButton}
                </Table>

                <Table
                    title={`Permissions for ${this.state.siteExploreResult?.site.displayName}`}
                    columns={SITE_PERMISSION_COLUMNS}
                    items={this.state.siteExploreResult?.permissions ? [this.state.siteExploreResult.permissions] : []}/>

            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): ExploreSitePageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        const siteId = ownProps.match.params.siteId;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            siteId: siteId,
            apiService: state.auth.apiService
        };
    }
)(ExploreSitePage)